import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: "pt",
  messages: {
    pt: {
      system_abbreviation: "POLICLINICAS",
      system_name: "SISTEMA INTEGRADO DE ACESSO ÀS POLICLÍNICAS",

      descriptions: {
        resource: "Recurso",
        faq: "Perguntas Frequentes",
        filters: "Filtros",
        forgot_my_password: "Esqueci minha senha",
        menu: "Menu",
        need_help: "Precisa de ajuda?",
        no_data_grid: "Não há dados disponíveis",
        reserved_rights: "© Todos os Direitos Reservados - SESAB",
        continue_or_change_polyclinic:
          "Gostaria de permanecer na policlinica atual ou escolher uma diferente?",
        login_error: "Ops! Algo deu errado ao tentar fazer o login",
        login_issue:
          "Lamentamos, mas enfrentamos um problema durante o seu login. Por favor, tente novamente. Se o problema persistir, entre em contato conosco",
        login_in_progress: "Seu login está em andamento",
        please_wait_moment: "Por favor, aguarde um momento",
        login_completed_successfully: "Login concluído com sucesso!",
        wait_while_redirecting: "Aguarde enquanto redirecionamos você",
        no_details: "Sem detalhes",
      },

      headers: {
        actions: "Ações",
        action: "Ação",
        cnes: "CNES",
        cns: "CNS",
        coverage: "Abrangência",
        county: "Município",
        cpf: "CPF",
        email: "E-mail",
        health_region: "Região de saúde",
        macro: "Macro",
        macroregion: "Macrorregião",
        name: "Nome",
        mother_name: "Nome da mãe",
        permissions: "Permissões",
        profile: "Perfil",
        status: "Status",
        uf: "UF",
        slug: "Slug",
        unity: "Unidade",
        type_unity: "Tipo de unidade",
        code: "Código",
        description: "Descrição",
        procedure_types: "Tipos de procedimento",
        personal_data: "Dados pessoais",
        address: "Endereço",
        documents: "Documentos",
        certificate: "Certidão",
        observations: "Observações",
        date_of_birth: "Data de nascimento",
        search: "Pesquisa",
        date_end: "Data final",
        date_start: "Data de inicio",
      },

      users: {
        name: "Usuário",
        add_user: "Cadastrar usuário",
        update_user: "Atualizar usuário",
      },

      patients: {
        list_patients: "Lista de pacientes",
        register_patient: "Adicionar paciente",
        update_patient: "Atualizar paciente",
        find_patients: "Encontrar pacientes",
        search_patients_description:
          "Para encontrar os pacientes realize uma busca por CPF ou CNS, Nome, Data de nascimento ou Nome da mãe",
        no_patients: "Nenhum paciente encontrado",
        no_search_patients_description:
          "Não foi possível encontrar nenhum registro com os dados fornecidos. Verifique os campos preenchidos e tente novamente",
      },

      profiles: {
        add_user: "Cadastrar perfil",
        list_profiles: "Lista de perfis",
        list_permissions: "Lista de permissões",
        update_user: "Atualizar perfil",
      },

      unities: {
        coverage_network: "Rede de abrangência",
        list_unities: "Lista de unidades",
        register_unity: "Cadastrar unidade",
        update_unity: "Atualizar unidade",
        ppp: "PPP de Imagem",
      },

      password: {
        check_code: "Código de verificação",
        check_email: "Verifique seu e-mail",
        check_email_box:
          "Enviamos o código de redefinição para o e-mail informado. Verifique sua caixa de entrada",
        check_email_spam:
          "Não recebeu o e-mail? Verifique sua caixa de spam ou",
        create_new_password: "Criar nova senha",
        info_email:
          "Informe o e-mail vinculado a sua conta e enviaremos um e-mail com instruções para ajudar na redefinição da sua senha.",
        password_reset: "Senha redefinida",
        report_code:
          "Informe o código que enviamos para prosseguir com a redefinição da sua senha",
        report_new_password: "Informe e confirme sua nova senha",
        reset_password: "Redefinição de senha",
        seconds: "segundos...",
        try_again: "tente novamente.",
        you_will_be_redirected: "Você será redirecionado para tela de login em",
        your_password_reset: "Sua senha foi redefinida com sucesso",
      },

      salutation: {
        good_afternoon: "Boa tarde",
        good_morning: "Bom dia",
        good_night: "Boa noite",
      },

      buttons: {
        active: "Ativar",
        add: "Adicionar",
        cancel: "Cancelar",
        clear: "Limpar",
        continue: "Continuar",
        delete: "Deletar",
        disable: "Desativar",
        filters: "Filtros",
        finalize: "Finalizar",
        return: "Voltar",
        save: "Salvar",
        search: "Pesquisar",
        submit: "Enviar",
        to_enter: "Entrar",
        verify: "Verificar",
        change_binds: "Alterar vínculos",
        fast_config: "Configuração expressa",
        find: "Buscar",
        find_again: "Buscar novamente",
        print_out: "Imprimir",
        exclude: "Excluir",
        include: "Incluir",
        distributeOffer: "Distribuir Oferta",
        releaseOffers: "Liberar Oferta",
        edit: "Editar",
        yes: "SIM",
        no: "NÃO",
        view: "Visualizar",
        reschedule: "Reagendar",
        coverage: "Abrangência",
        route: "Rota",
        stopping_point: "Ponto de Parada",
        exit: "SAÍDA",
        sex: "Sexo",
        change_unity: "Alterar unidade",
        change_unity_profile: "Alterar unidade/perfil",
        try_again: "tente novamente.",
        justification: "Justificativa",
      },

      dashboard: {
        schedule: "AGENDAMENTO",
        passenger: "PASSAGEIRO",
        vacancies: "CEDÊNCIA DE VAGAS",
        idle_vacancies: "VAGAS OCIOSAS",
        consult: "CONSULTAS",
        exams: "EXAMES",
      },

      inputs: {
        accreditation_level: "Nível de acreditação",
        address_line: "Logradouro",
        administrative_sphere: "Esfera administrativa",
        aghuse_code: "Código AGHUse",
        aghuse_integration: "Integração com AGHUse",
        date_of_issue_rg: "RG",
        ddd: "DDD",
        alternate_phone: "Telefone alternativo",
        captcha: "Captcha",
        cell_phone: "Celular",
        cep: "CEP",
        cnes: "CNES",
        complement: "Complemento",
        confirm_new_passoword: "Confirmar senha",
        corporate_name: "Razão social",
        county: "Município",
        county_origin: "Município Origem",
        county_destiny: "Município Destino",
        competence: "Competência",
        cpf: "CPF",
        date: "Data",
        start_date: "Data de início",
        end_date: "Data final",
        description: "Descrição",
        destiny: "Destino",
        district: "Bairro",
        driver: "Motorista",
        email: "E-mail",
        health_region: "Região de saúde",
        institution_name: "Nome da instituição",
        main_phone: "Telefone principal",
        macro_region: "Macrorregião",
        name: "Nome",
        new_password: "Nova senha",
        number: "Número",
        organization_nature: "Natureza da organização",
        password: "Senha",
        profile: "Perfil",
        search_by_name: "Nome",
        social_name: "Nome social",
        full_name: "Nome Completo",
        status: "Status",
        type_unity: "Tipo da unidade",
        uf: "UF",
        unity: "Unidade",
        unity_responsible: "Diretor Clínico/Gerente/Administrador",
        ppp: "Solicita PPP de Imagem?",
        types_procedures: "Tipos de procedimento",
        father_name: "Nome do pai",
        mother_name: "Nome da mãe",
        gender: "Sexo",
        gender_identity: "Identidade de Gênero",
        color: "Cor",
        marital_status: "Estado civil",
        nationality: "Nacionalidade",
        place_of_birth: "Naturalidade",
        education_level: "Grau de instrução",
        occupation: "Ocupação",
        home_phone: "Telefone residencial",
        additional_phone: "Telefone adicional",
        naturalized_brazilian: "Naturalizado brasileiro",
        date_of_entry_brazil: "Data de entrada no Brasil",
        date_of_naturalization: "Data de naturalização",
        ordinance: "Portaria",
        correspondence: "Correspondência",
        rg: "RG",
        issuing_authority: "Órgão emissor",
        date_of_issue: "Data de emissão",
        cns: "CNS",
        mother_cns: "CNS da mãe",
        documents_presented: "Documentos apresentados",
        type_of_certificate: "Tipo de certidão",
        registration: "Registro",
        registry_office_name: "Nome do cartório",
        book: "Livro",
        pages: "Folhas",
        term: "Termo",
        birth_certificate_number: "Número da DN (Documento de Nascimento)",
        date_of_birth: "Data de nascimento",
        municipality: "Município",
        type: "Tipo",
        observations: "Observações",
        patient_name: "Nome do paciente",
        patient_cpf: "CPF do paciente",
        patient_cns: "CNS do paciente",
        patient_cpf_cns: "CPF ou CNS do paciente",
        patient_mother_name: "Nome mãe do paciente",
        seat_number: "Número da poltrona",
        deficiency: "Deficiência",
        question_companion: "Possui Acompanhante?",
        companion: "Acompanhante",
        seat_number_companion: "Número da poltrona do acompanhante",
        health_unit: "Unidade de Saúde Destino",
        stop_points: "Ponto de Parada",
        speciality: "Especialidade",
        executing_unit: "Unidade Executora",
        seat: "Poltrona",
        offered: "Ofertado/Mês",
        year: "Ano",
        mounth: "Mês",
        start_month: "Mês de Início",
        end_month: "Mês de Fim",
        start_year: "Ano de Início",
        end_year: "Ano de Fim",
        procedure: "Procedimento",
        procedures: "Procedimentos",
        exam: "Grupo de Exames",
        license_number: "N. da Habilitação",
        mother: "Nome da Mãe",
        due_date: "Dt. Vencimento",
        category: "Categoria",
        polyclinic: "Policlinica",
        route: "Rota",
        estimated_time: "Tempo Estimado Percuso (Horas)",
        total_Km: "Km Total da Rota",
        transport: "Transporte",
        plate: "Placa",
        plate_transport: "Placa do Veículo",
        professional: "Profissional",
        health_professional: "Profissional de Saúde",
        seats: "Qtd. Assentos",
        trip_hour: "Hora da Viagem",
        trip_name: "Nome da Viagem",
        phone: "Telefone",
        matriculate: "Matrícula",
        search_county: "Município",
        image_header: "Imagem de cabeçalho",
        justification_cancellation: "Justificativa do cancelamento",
        type_cession: "Tipo de cessão",
        vacancies: "Vagas",
        crm: "CRM",
        matriculate_convenant: "Matrícula Convênio",
        cbo: "CBO",
        external_doctor: "Médico Externo / Solicitante",
        justification: "Justificativa",
      },

      placeholder: {
        email: "email@exemplo.com",
      },

      helpers: {
        chat: {
          user_support: "Atendimento ao usuário",
          support: "suporte",
          greeting: "Bem-vindo(a) ao suporte do",
          how_can_help_you: "No que posso ajudar?",
          im_doubt: "Estou com dúvida",
          submit_suggestion_bug: "Enviar sugestão ou bug",
          suggestion_bug: "Sugestão/Bug",
          need_help: "Preciso de ajuda",
          doubt_message:
            "Caso esteja com dúvidas sobre a utilização do sistema, contamos com uma sessão de",
          learn_more: "e saiba mais",
          sugestion_message:
            "Para que possamos melhorar cada vez mais, contamos com sua ajuda. Descreva abaixo sua sugestão ou bug.",
          return: "Retornar",
          needHelpTitle:
            "Preciso de algumas informações sobre o problema. Selecione uma das categorias.",
          permissions: "Permissões",
          my_account: "Minha conta",
          permissions_message:
            "O sistema exibe avisos caso você esteja tentando acessar uma página ou realizar alguma ação que não possui permissão.",
          error_permissions_message:
            "Caso esteja enfrentando outros problemas de permissão, você pode acessar o",
          permissions_contact: "ou entrar em contato clicando no botão abaixo.",
          permissions_error: "Problema com permissões",
          account_title: "Ok. Selecione uma categoria para continuar",
          contact: "Entrar em contato",
          password_reset: "Redefinição de senha",
          incorrect_data: "Dado incorreto",
          error_incorrect_data: "Problema com dado incorreto",
          password_error: "Problema com senha",
          password_message: "Entendo. Sugiro a leitura do",
          about_reset_password: "sobre redefinição de senha.",
          password_problem_not_listed:
            "Caso o seu problema não esteja listado ou não tenha sido resolvido com o FAQ, sugiro que entre em contato com nosso suporte clicando no botão abaixo",
          infos_message:
            "Para que seus dados sejam corrigidos, preciso que você me informe o nome do campo que está incorreto e o novo valor que deseja utilizar.",
          correction_to_be_made:
            "Caso exista mais de uma correção a ser feita, separe os campos por vírgula.",
          example: "Exemplo",
          example_infos: "nome: novo nome, e-mail: novo@email.com",
          success_message:
            "O nosso suporte irá avaliar as informações enviadas e assim que possível você será notificado por e-mail.",
          feedback_error: "Erro ao enviar feedback.",
        },

        faq: {
          abbreviation: "FAQ",
          faq: "Perguntas Frequentes",
        },
      },

      menu: {
        actions_menu: "Menu de ações",

        actions: {
          activate: "Ativar",
          coverage: "Abrangências",
          delete: "Deletar",
          inactivate: "Inativar",
          permissions: "Permissões",
          update: "Editar",
        },
      },

      status: {
        active: "Ativo",
        inactive: "Inativo",
        undefined: "Indefinido",
      },

      modals: {
        activate: "Ativar",
        activate_registration_title: "Confirmação de Ativação",
        activate_registration_description:
          "Você está prestes a ativar o registro selecionado. Ao fazer isso, o registro será habilitado para processar dados e realizar ações específicas.",

        disable: "Desativar",
        disable_registration_title: "Confirmação de Desativação",
        disable_registration_description:
          "Você está prestes a desativar o registro selecionado. Ao fazer isso, o registro será desabilitado e deixará de executar suas funcionalidades.",

        delete: "Deletar",
        delete_registration_title: "Confirmação de Exclusão",
        delete_registration_description:
          "Você está prestes a excluir o modelo selecionado. Ao fazer isso, o modelo será removido permanentemente do sistema. ",
      },

      messages: {
        // success
        success_add: "Registro adicionado com sucesso",
        success_active: "Status do registro alterado para ativo",
        success_bind_coverage_unity: "Registro(s) vinculado(s) com sucesso!",
        success_change_status: "Status alterado com sucesso!",
        success_delete: "Registro removido com sucesso",
        success_inactive: "Status do registro alterado para inativo",
        success_update: "Registro atualizado com sucesso",
        success_find: "Registro encontrado",
        success_seach: "Encontramos um registro com os dados fornecidos",

        // warnings
        check_fields: "Verifique os campos e tente novamente",
        no_register_selected: "Selecione um registro para continuar",

        // Erros
        error_add: "Erro ao cadastrar registro",
        error_bind_coverage_unity: "Ocorreu um erro ao vincular a unidade",
        error_change_status: "Ocorreu um erro ao alterar o status",
        error_login: "Erro ao realizar login",
        error_not_defined: "Ops! Ocorreu um erro",
        error_address_correspondence: "O endereço não corresponde",
        error_password_not_match: "As senhas informadas não correspondem",
        error_query: "Erro ao realizar consulta",
        error_try_login: "Erro ao tentar realizar o login",
        error_update: "Erro ao atualizar registro",
        error_address_home: "Erro com o endereço",
        error_address: "Erro com o endereço",
        error_cep: "Erro de CEP",
      },
      salutations: {
        good_morning: "Bom dia",
        good_night: "Boa noite",
        good_afternoon: "Boa tarde",
        welcome: "Bem vindo(a)",
      },
    },
  },
});

export default i18n;
